var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", [_c("a-modal", {
    attrs: {
      title: _vm.$t("消息内容"),
      maskClosable: false,
      footer: null,
      width: 600,
      wrapClassName: "message-detail-model"
    },
    on: {
      cancel: _vm.close
    },
    model: {
      value: _vm.visible,
      callback: function ($$v) {
        _vm.visible = $$v;
      },
      expression: "visible"
    }
  }, [_vm.systemForcePopMessageList.length > 0 ? _c("div", {
    staticClass: "message-container-force"
  }, [_c("h2", {
    staticClass: "message-title"
  }, [_vm._v(" " + _vm._s(_vm.systemForcePopMessageList[_vm.index].title || "") + " ")]), _c("div", {
    staticClass: "message-time"
  }, [_vm._v(_vm._s(_vm.systemForcePopMessageList[_vm.index].receptionTime || ""))]), _c("div", {
    staticClass: "ql-container message-content ql-snow"
  }, [_c("div", {
    staticClass: "ql-editor",
    domProps: {
      innerHTML: _vm._s(_vm.systemForcePopMessageList[_vm.index].content)
    }
  })]), _vm.systemForcePopMessageList[_vm.index] && _vm.systemForcePopMessageList[_vm.index].fileList ? _c("div", {
    staticClass: "file-list"
  }, _vm._l(_vm.systemForcePopMessageList[_vm.index].fileList, function (item) {
    return _c("div", {
      key: item.uid,
      staticClass: "file-item"
    }, [_c("a-tooltip", {
      attrs: {
        title: item.name,
        placement: "topLeft",
        overlayStyle: {
          zIndex: 3000
        }
      }
    }, [_c("span", {
      staticClass: "file-name"
    }, [_vm._v(_vm._s(item.name))])]), _c("a-icon", {
      staticClass: "icon-class",
      staticStyle: {
        "margin-right": "10px"
      },
      attrs: {
        type: "eye"
      },
      on: {
        click: function ($event) {
          return _vm.preview(item);
        }
      }
    }), _c("a-icon", {
      staticClass: "icon-class",
      attrs: {
        type: "download"
      },
      on: {
        click: function ($event) {
          return _vm.download(item);
        }
      }
    })], 1);
  }), 0) : _vm._e()]) : _vm._e(), _c("div", {
    staticStyle: {
      "text-align": "right"
    }
  }, [_vm.systemForcePopMessageList.length > 1 && _vm.index !== _vm.systemForcePopMessageList.length - 1 ? _c("a-button", {
    attrs: {
      type: "primary"
    },
    on: {
      click: _vm.next
    }
  }, [_vm._v(_vm._s(_vm.$t("下一步")))]) : _vm._e()], 1)]), _c("preview-modal", {
    attrs: {
      visible: _vm.previewVisible,
      videoTypeList: ["mp4"],
      fileList: _vm.fileList,
      show: _vm.fileType,
      src: _vm.previewSrc,
      currentIndex: _vm.currentPreviewIndex
    },
    on: {
      cancel: _vm.cancelPre
    }
  })], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };